import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: false });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("primrose_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Generic resource helpers
export const list = (resource, params = {}) => api.get(`/${resource}`, { params }).then((r) => r.data);
export const getOne = (resource, id) => api.get(`/${resource}/${id}`).then((r) => r.data);
export const create = (resource, body) => api.post(`/${resource}`, body).then((r) => r.data);
export const update = (resource, id, body) => api.put(`/${resource}/${id}`, body).then((r) => r.data);
export const remove = (resource, id) => api.delete(`/${resource}/${id}`).then((r) => r.data);

export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export const fileUrl = (path) => {
  if (!path) return "";
  const token = localStorage.getItem("primrose_token");
  return `${API}/files/${path}/download?auth=${token}`;
};

export default api;
